<script>
export let currentRoute;


import HotelCard from 'components/views/my/hotels/thumbs/Hotel.svelte';


import SvelteSeo from 'svelte-seo';


const hotels = [
	{
		href: '/files/AHG-CODE-OF-CONDUCT-2025.pdf',
		city: 'Coaches Guide',
	},
]



</script>


<style>
	

</style>



<SvelteSeo
	title='Coaches Guide | AHG Coaches Portal'
	description='Coaches Guide!'
/>



<section class="hero bg-grey">

	<div class="hero-body">

		<div class="container">

			<p class="hero-subtitle has-text-centered">
				Coaches Guide
			</p>

		</div>

	</div>
	
</section>



<section class="section">

	<div class="container">

		<div class="columns is-centered">

			<div class="column is-9-desktop is-10-tablet is-12-mobile">

				<div class="columns is-variable is-3 is-mobile is-multiline is-centered">

					{#each hotels as hotel}

						<div class="column is-6-desktop is-12-touch">

							<HotelCard {hotel} />

						</div>

					{/each}

				</div>

			</div>

		</div>

	</div>

</section>



